import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import Arrow from './SecondaryNavMobileSubMenuArrow';
import Close from './SecondaryNavMobileSubMenuClose';

import * as styles from './SecondaryNavMobile.module.less';

const SecondaryNavMobileHeader = ({ isOpen, onClick, text }) => {
  const exploreText = `Explore${text ? ` ${text}` : ''}`;
  return (
    <a
      className={classnames(styles.header, styles.headerContainer, {
        [styles.headerOpen]: isOpen,
      })}
      onClick={onClick}
    >
      {exploreText}
      <Text className={styles.subMenu__arrow}>
        {isOpen ? <Close /> : <Arrow />}
      </Text>
    </a>
  );
};

SecondaryNavMobileHeader.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

SecondaryNavMobileHeader.defaultProps = {
  isOpen: false,
  onClick: () => {},
  text: '',
};

export default SecondaryNavMobileHeader;
